export const mk = {
    LEFT: 'Лево: Премести на претходниот ден.',
    RIGHT: 'Десно: Премести за наредниот ден.',
    DOWN: 'Долу: се Движи кон следниот ред.',
    UP: 'До: се Движи на претходниот ред.',
    PGUP: 'PgUp: се Движи на претходниот месец.',
    PGDOWN: 'PgDown: се Движи кон следниот месец.',
    HOME: 'Home: се Движи на претходната година.',
    END: 'Крај: Преселат на следната година.',
    ESC: 'Esc/Денес/Close: ја затворите календар.',
    TITLE: 'Тастатура Инструкции'
};
